export function ajaxMap() {
    $('#form-location').change(function () {
        let data = $(this).serialize();

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: {
                action: 'load_location',
                state: data,
            },
            type: 'POST',
            success: function success(response) {
                if (response) {
                    $('.home-map-wrap .select-result').html(response.content);
                }
            }

        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ajax-map.js